import { Shield } from "lucide-react";
import { formatCVSS } from "./utils";

interface CVSSScoreDisplayProps {
  score: number;
  showIcon?: boolean;
  className?: string;
}

export function CVSSScoreDisplay({ score, showIcon = false, className }: CVSSScoreDisplayProps) {
  return (
    <div className={`flex items-center gap-2 ${className || ''}`}>
      {showIcon && <Shield className="h-4 w-4 text-muted-foreground" />}
      <span className="text-2xl font-bold">
        {formatCVSS(score)}
        <span className="text-sm text-muted-foreground ml-1">/10</span>
      </span>
    </div>
  );
}
